const styles = (theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  pageLabel: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #EAEAEA',
    borderLeft: 'none',
    padding: `0 ${theme.spacing.unit * 3.5}px 0`,
    fontSize: '1rem',
    [theme.breakpoints.up('sm')]: {
      padding: `0 ${theme.spacing.unit * 2}px 0`,
    },
  },
  button: {
    border: '1px solid #EAEAEA',
    borderLeft: 'none',
    borderRadius: 0,
    color: theme.palette.text.dark,
    padding: 3,
    minWidth: 40,
    [theme.breakpoints.up('sm')]: {
      minWidth: 60,
    },
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      color: '#BDBDBD',
    },
  },
  buttonFirst: {
    borderLeft: '1px solid #EAEAEA',
    borderRadius: '45% 0 0 45%',
  },
  buttonLast: {
    borderRadius: '0 45% 45% 0',
  },
  icon: {
    fontSize: '1.75rem',
  },
});

export default styles;
